import 'bootstrap-icons/font/bootstrap-icons.css';

document.addEventListener('DOMContentLoaded', function() {
  const body = document.body;
  const btn = document.getElementById('themeToggle');
  const icon = document.getElementById('themeIcon');
  const logo = document.getElementById('headerLogo');
  const sidebar = document.querySelector('.sidebar'); // Добавь класс .sidebar для левого блока

  // Проверяем, не была ли выбрана тема ранее
  let isDark = localStorage.getItem('theme');
  if (isDark === null) {
    isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  } else {
    isDark = isDark === 'dark';
  }


  function setTheme(dark) {
    if (dark) {
      body.classList.add('bg-dark', 'text-light');
      icon.className = 'bi bi-sun';
      if (logo) logo.src = logo.dataset.srcDark || '/static/img/logo-trade-dark.svg';
      if (sidebar) sidebar.classList.add('sidebar-dark');
      if (sidebar) sidebar.classList.remove('sidebar-light');
      localStorage.setItem('theme', 'dark');
    } else {
      body.classList.remove('bg-dark', 'text-light');
      icon.className = 'bi bi-moon';
      if (logo) logo.src = logo.dataset.srcLight || '/static/img/logo-trade-light.svg';
      if (sidebar) sidebar.classList.remove('sidebar-dark');
      if (sidebar) sidebar.classList.add('sidebar-light');
      localStorage.setItem('theme', 'light');
    }
    //  после смены темы вызов события
    window.dispatchEvent(new Event('themechanged'));
  }

  setTheme(isDark);

  btn && btn.addEventListener('click', function() {
    isDark = !body.classList.contains('bg-dark');
    setTheme(isDark);
  });

    // --- Универсальная функция для переключения PNG ---
  function updateThemePNGs() {
    const isDark = body.classList.contains('bg-dark');
    document.querySelectorAll('img[data-src-light][data-src-dark]').forEach(img => {
      img.src = isDark ? img.dataset.srcDark : img.dataset.srcLight;
    });
  }

  // Слушаем смену темы и обновляем PNG
  window.addEventListener('themechanged', updateThemePNGs);

  // При первой загрузке страницы (актуально для уже выбранной темы)
  updateThemePNGs();

  // Экспорт для вызова после вставки динамического контента (например в дашборде)
  window.updateThemePNGs = updateThemePNGs;

});
